/**
 * legacy <form> 包裝層 spec 表——GNL-005-b（批次 36，Gitea issue #38）。
 *
 * 【來源】R2 structure-diff 缺元素 L:form 76 筆/71 頁（legacy raw-dom 逐 form 的
 * action/method/target 原文程式化萃取）。裁決（使用者 2026-09-30）：**補齊 form
 * （分段）**——延伸 SearchPanel「刻意保留原生 form onSubmit」決策；normalize
 * ATTR_ALLOW 含 action/method/target、不含 class/id/onsubmit → 裸 <form> 與
 * legacy 無 action form 等值、具名 action 群寫死同值即等值。
 *
 * 【白名單制】formSpecFor 只對本表內的頁回 spec（FormWrap/ReportPanel 才包 form）；
 * 不在表＝不包。R-diff 驗證（41 頁 DIFF_ONLY）為「包了會位移劣化」的 20 頁
 * （d>+2：legacy form 內容≠react 查詢區內容——日期 input/radio 群/說明 label 等
 * 缺項 → form 對 form 嚴格對位 off-by-N 級聯）已剔除，其 L:form 殘餘＝AD 登記，
 * 深對位歸模組批逐頁處理。逐頁 verdict 見批次 36 進度檔。
 *
 * 【為什麼是這些條】legacy form＝查詢/參數欄位＋動作鈕的送出語意載體（不含表格；
 * class/id/onsubmit 不進比對）。mock-only 不真送出（onSubmit preventDefault 由頁面
 * 行為承擔），attr 鏡像只為 diff 等值。
 *
 * 【多 form 頁】form-co-edit-form-fill-form／form-plan-form-dispatch／
 * customer-tsgh-clert-cerk／training-permission-manage-student／-teacher 各有次要
 * form（隱藏 POST/topForm 類）＝Phase 2 body 內個別處理，本表只收各頁主要 form
 * （nodes 最大者）。
 */
export interface LegacyFormSpec {
  /** 鏡像 legacy form action（無＝裸 form）。 */
  readonly action?: string;
  /** 鏡像 legacy form method（照 legacy 大小寫：POST/post）。 */
  readonly method?: string;
  /** 鏡像 legacy form target（printForms 的 _blank）。 */
  readonly target?: string;
}
export const LEGACY_FORM_SPECS: Readonly<Record<string, LegacyFormSpec>> = {
  "report-tsgh-academic-mom": { method: "POST" },
  "report-ugywm-student-dept-satisfy": { action: "/tsghrpt/ugywm/studentDeptSatisfy", method: "POST" },
  "leave-leave-holiday": {  },
  "report-tsgh-core-skill-statistic-report": { action: "/nothing", method: "POST" },
  "system-api-log": {  },
  "system-download-log": {  },
  "system-system-config": { action: "/system/systemConfig/saveSystemConfig", method: "POST" },
  // W11（批次 42，issue #40，裁決④案 B）：organization.jsp:343 raw 原文（method 小寫 get
  // 照 raw 保真）；SearchPanel 消費面＝CrudListPage 傳 formSpecFor(pageId)（白名單制，
  // 白名單其他 7 條非 crud-list 頁零影響——routes pageType 實盤 2026-10-01）。
  "config-organization": { action: "/system/", method: "get" },
  // 批次 44（#42 GNL-005-f）：W11 白名單延伸（raw-dom 逐 form 萃取原文）。
  // planTargetList.jsp 查詢 form action=/instruction/planTargetList method=POST。
  "instruction-plan-target-plan-target-list": { action: "/instruction/planTargetList", method: "POST" },
  // 批次 44：planInstList queryForm action=/training/planInst/planInstList（raw-dom form[2] 原文；
  // issue 口徑的「/」為舊資料）。
  "training-plan-inst-plan-inst-list": { action: "/training/planInst/planInstList", method: "POST" },
  // 批次 44：planFormList.jsp:548 searchForm（配對成立後欄位級真修面逐項浮現；屬性差 -1）。
  "form-plan-form-list": { action: "/form/planFormList", method: "POST" },
};

/** 查某頁的 form spec；未登錄回 undefined＝不包 form（R-diff verdict SKIP 群）。 */
export function formSpecFor(pageId: string): LegacyFormSpec | undefined {
  return LEGACY_FORM_SPECS[pageId];
}
